<app-menu-crud-panel-top [rows]="recordRowsLogs" [conf]="recordConfBtns" [toggle]="layoutAsToggle">
	<!--	<app-chart-meds-consistency PanelTop></app-chart-meds-consistency>-->
</app-menu-crud-panel-top>